import React, { FC } from 'react';

import PopoverButton from '../../../../../../components/PopoverButton';
import AddPlayerForm from '../AddPlayerForm/AddPlayerForm';
import { AddGuestPlayerPopOverStyled } from './AddGuestPlayerPopOver.Styles';
import { AddGuestPlayerButton } from './AddGuestPlayerButton';

const AddGuestPlayerPopOver: FC = () => {
  return (
    <AddGuestPlayerPopOverStyled>
      <PopoverButton
        id="add-player"
        buttonContent={<AddGuestPlayerButton />}
        origin="center"
        popoverProps={{
          className: 'add-player-popover staff-scope'
        }}
      >
        <AddPlayerForm />
      </PopoverButton>
    </AddGuestPlayerPopOverStyled>
  );
};

export default AddGuestPlayerPopOver;
